// React import is required because the react-selct is using React 16, which requires it for JSX.

import React from 'react'
import { OptionProps } from 'react-select'

import { useSelectSearchable } from '~/components/SelectSearchable/useSelectSearchable'

import AudienceCard from '../../../Audiences/Card'

const CustomOptionAudience: React.FC<OptionProps<ValueOptionAudience>> = ({
  data,
  isDisabled,
  isFocused,
  isSelected,
  innerProps
}) => {
  const { selectedAudienceId, ...audience } = data
  const { optionStyles } = useSelectSearchable({
    isDisabled,
    isSelected,
    isFocused
  })

  return (
    <section className="border-bottom" {...innerProps}>
      <AudienceCard
        data={audience}
        selectedAudienceId={selectedAudienceId}
        isFocused={isFocused}
        style={{
          ...optionStyles,
          alignItems: 'stretch'
        }}
      />
    </section>
  )
}

export default CustomOptionAudience
